export default {
  title: {
    'zh-cn': '设备配置',
    'zh-tw': '設備配置',
    'en': 'Device Configuration'
  }
}

